
import { Link } from "react-router-dom";
import { ThumbsUp } from "lucide-react";

interface BrandLogoProps {
  className?: string;
  to?: string;
  linkClassName?: string;
}

export const LogoIcon = ({ className = "" }: { className?: string }) => (
  <div className={`bg-whatsapp rounded-md p-1 md:p-1.5 ${className}`}>
    <ThumbsUp className="h-5 w-5 md:h-6 md:w-6 text-white" />
  </div>
);

const LogoContent = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`flex items-center gap-1.5 md:gap-2 ${className}`}>
      <LogoIcon />
      <div className="flex items-baseline whitespace-nowrap">
        <span className="font-heading text-lg font-bold text-brand-ink md:text-2xl">WhatsGood</span>
        <span className="ml-1 rounded-md bg-whatsapp px-1.5 py-0.5 font-heading text-sm font-bold leading-none text-white md:text-base">HK</span>
      </div>
    </div>
  );
};

const BrandLogo = ({ className = "", to = "/", linkClassName = "" }: BrandLogoProps) => {
  // If no 'to' is provided, render without Link
  if (to === null) {
    return <LogoContent className={className} />;
  }
  
  // Otherwise wrap in a Link
  return (
    <Link to={to} className={linkClassName}>
      <LogoContent className={className} />
    </Link>
  );
};

export default BrandLogo;
